import { RouteComponentProps } from '@reach/router';
import React, { Component } from 'react';
import { OIDC_SIGNIN } from 'routes/paths';

/**
 * "Redirect" users to the correct path after they sign in.
 *
 * The login process sends users to /oidc_signin first before ultimately changing the URL
 * to the correct path.
 *
 * However, React Router doesn't "hear" the URL change, and it still renders the page for
 * /oidc_signin. So we poll window.location and "redirect" to it when it changes.
 */
export class RedirectAfterOidcSignin extends Component<RouteComponentProps> {
    componentDidMount(): void {
        const intervalId = setInterval(() => {
            if (location.pathname.startsWith(OIDC_SIGNIN)) {
                return;
            }

            clearInterval(intervalId);

            // "Redirect" to the same location
            const { navigate } = this.props;
            if (!navigate) {
                console.warn("Can't redirect back to correct URL: navigate() function was not provided by the router");
                return;
            }
            navigate(location.pathname + location.search + location.hash);
        }, 50);
    }

    render() {
        return <></>;
    }
}
